import { c as _c } from "react/compiler-runtime";
import { useMetadataStore } from '@/store';
import { useAppLocale } from './use-app-locale';

/**
 * Hook to access metadata from store with destructuring
 * @returns Object with metadata properties that can be destructured
 * @example const { title, description, activeLocales } = useMetadata()
 */
export const useMetadata = () => {
  const $ = _c(22);
  const metadata = useMetadataStore(_temp);
  const {
    backendLocale
  } = useAppLocale();
  let socialMediaLinks;
  if ($[0] !== metadata?.generalSettings.facebook || $[1] !== metadata?.generalSettings.instagram || $[2] !== metadata?.generalSettings.linkedin || $[3] !== metadata?.generalSettings.twitter || $[4] !== metadata?.generalSettings.youtube) {
    socialMediaLinks = [];
    if (metadata?.generalSettings.facebook) {
      socialMediaLinks.push(metadata?.generalSettings.facebook);
    }
    if (metadata?.generalSettings.instagram) {
      socialMediaLinks.push(metadata?.generalSettings.instagram);
    }
    if (metadata?.generalSettings.linkedin) {
      socialMediaLinks.push(metadata?.generalSettings.linkedin);
    }
    if (metadata?.generalSettings.youtube) {
      socialMediaLinks.push(metadata?.generalSettings.youtube);
    }
    if (metadata?.generalSettings.twitter) {
      socialMediaLinks.push(metadata?.generalSettings.twitter);
    }
    $[0] = metadata?.generalSettings.facebook;
    $[1] = metadata?.generalSettings.instagram;
    $[2] = metadata?.generalSettings.linkedin;
    $[3] = metadata?.generalSettings.twitter;
    $[4] = metadata?.generalSettings.youtube;
    $[5] = socialMediaLinks;
  } else {
    socialMediaLinks = $[5];
  }
  const t0 = metadata?.contentSettings?.title?.[backendLocale] || "";
  const t1 = metadata?.contentSettings?.description?.[backendLocale] || "";
  const t2 = metadata?.contentSettings?.keywords?.[backendLocale] || "";
  let t3;
  if ($[6] !== metadata?.locales) {
    t3 = metadata?.locales || [];
    $[6] = metadata?.locales;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== metadata?.locales) {
    t4 = metadata?.locales?.filter(_temp2).sort(_temp3) || [];
    $[8] = metadata?.locales;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== metadata?.routeParams) {
    t5 = metadata?.routeParams || {};
    $[10] = metadata?.routeParams;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = metadata?.generalSettings;
  let t7;
  if ($[12] !== metadata || $[13] !== socialMediaLinks || $[14] !== t0 || $[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = {
      metadata,
      title: t0,
      description: t1,
      keywords: t2,
      locales: t3,
      activeLocales: t4,
      routeParams: t5,
      generalSettings: t6,
      socialMediaLinks
    };
    $[12] = metadata;
    $[13] = socialMediaLinks;
    $[14] = t0;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export default useMetadata;
function _temp(state) {
  return state.metadata;
}
function _temp2(l) {
  return l.active;
}
function _temp3(a, b) {
  return a.order - b.order;
}